import {
    calculateTax,
    globalFn,
} from '../invoiceUtils'

export default class Goods {
    constructor() {
        Object.assign(this, {
            adValoremTotal: '', // 价税合计 ,
            amount: '', // 不含税金额 ,
            balance: 0.00, // 差额 ,
            lineNature: '0', // 行性质,0(商品行);1(折扣行) ,
            matName: '', // 商品名称 ,
            price: '', // 不含税单价 ,
            quantity: '', // 数量 ,
            serialNo: 1, // 序号 ,
            shortAndMatName: '', // 商品全称 ,
            isPrivilege: '0',
            spec: '', // 规格型号 ,
            taxAmount: '', // 税额 ,
            taxPrice: '', // 含税单价 ,
            taxRate: '', // 税率 ,
            taxRateArr: [],
            unit: '', // 单位 ,
        })
    }

    /**
     * 从商品信息构建
     * @param  {object} goodsInfo [e税云商品信息对象]
     */
    fromGoods(goodsInfo) {
        const goods = this
        goods.zeroTax = ''
        // add by zmh end
        goods.taxRate = goodsInfo.taxRate // 税率
        goods.taxMergeCode = goodsInfo.taxMergeCode // 税分编码
        goods.revenueCode = goodsInfo.taxMergeCode // 
        goods.isPrivilege = goodsInfo.isPrivilege // 优惠政策
        goods.privilegeType = goodsInfo.privilegeType // 优惠政策类型

        goods.typeName = goodsInfo.matCalss ? goodsInfo.matCalss : goods.typeName
        goods.revenueVersion = goodsInfo.codeVersions ? goodsInfo.codeVersions : goods.revenueVersion
        goods.taxAmount = ''
        goods.quantity = goods.quantity // 数量
        if (goods.isTax == 1) {
            goods.$adValoremTotal = goods.adValoremTotal // 计算一次，目的是传入的商品没有单价的情况下也能计算税额
        } else {
            goods.$amount = goods.amount
        }
        goods.isTax = `${goodsInfo.taxInclud}`
        // goods.amount = goods.amount
        // goods.adValoremTotal = goods.adValoremTotal
        // 简称
        // goods.shortAndMatName = `*${goodsInfo.taxShortName}*${goodsInfo.goodsName}`

        if (goodsInfo.isGoodsInfoTab) { // 从商品信息tab选择
            goods.revenueName = goodsInfo.taxShortName // 简称
            goods.matName = goodsInfo.goodsName // 名称
            goods.spec = goodsInfo.specifications // 规格
            goods.unit = goodsInfo.measureUnit // 单位
            goods.matCode = goodsInfo.goodsCode // 商品编码
        } else { // 从分类编码tab选择
            goods.revenueName = goods.revenueName ? goods.revenueName : goodsInfo.taxShortName // 简称(已选商品不更新这些字段，空商品行仍带出这些字段)
            goods.matName = goodsInfo.goodsName ? goodsInfo.goodsName : goods.matName // 名称
            goods.spec = goods.spec ? goods.spec : goodsInfo.specifications // 规格
            goods.unit = goods.unit ? goods.unit : goodsInfo.measureUnit // 单位
            goods.matCode = goods.matCode // 商品编码
        }
        goods.shortAndMatName = `*${goods.revenueName}*${goods.matName}`


        if (goodsInfo.price) {
            if (goodsInfo.taxInclud === 1) {
                goods.$taxPrice = goodsInfo.price
            } else {
                goods.$price = goodsInfo.price
            }
        }
        // 设置零税率
        if (goodsInfo.isPrivilege != 1 && goodsInfo.taxRate === 0) {
            goods.zeroTax = '3'
        }
        this.setDefaultTaxRateArr()
        return goods
    }

    fromInvoiceDetail(detail) {
        Object.assign(this, detail)
        this.taxMergeCode = detail.revenueCode;
        (detail.taxRateArr && detail.taxRateArr.length) || this.setDefaultTaxRateArr()
        return this
    }

    setDefaultTaxRateArr() {
        const goods = this
        const taxText = goods.isPrivilege === '1' ? goods.privilegeType : (goods.taxRate == 10.02 ? '' : `${goods.taxRate * 100}%`)
        goods.taxRateObj = {
            taxRate: goods.taxRate,
            isPrivilege: goods.isPrivilege,
            privilegeType: goods.isPrivilege,
            taxText,
        }
        goods.taxRateArr = [goods.taxRateObj]
    }

    // 不含税金额
    get $amount() {
        return this.amount
    }

    // 不含税金额
    set $amount(amount) {
        const goods = this
        if ((!goods.taxRate && goods.taxRate !== 0) || !goods.isAmountSetable(amount)) {
            return
        }
        goods.amount = amount
        if (!amount || amount === '-') {
            return
        }
        // 计算税额
        goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(amount - goods.balance, goods.taxRate, goods.isTax))
        // 价税合计
        goods.adValoremTotal = globalFn.Add(amount, goods.taxAmount)
        // 没有数量有单价 反算数量
        if (goods.price && goods.price != 0 && !goods.quantity) {
            goods.quantity = globalFn.cutOutPnumber(globalFn.Div(amount, goods.price), 15)
            // 没有单价有数量 反算单价
        } else if (goods.quantity && goods.quantity != 0 && goods.quantity) {
            goods.price = globalFn.cutOutPnumber(globalFn.Div(amount, goods.quantity), 15)
            goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, this.quantity), 15)
        }
        //完成所有计算后再保留两位小数
        goods.taxAmount = Number(goods.taxAmount).toFixed(2)
        goods.adValoremTotal = Number(goods.adValoremTotal).toFixed(2)
    }

    isAmountSetable(amount = this.amount) {
        // 可以不输入，如果放开限制，将不能清空输入框
        if (!amount || (!this.isRed && /^\d{1,11}(\.\d{0,2})?$/.test(amount)) ||
            (this.isRed && /^-\d{0,12}(\.\d{0,2})?$/.test(amount)) || this.isBill) {
            return true
        }
        return false
    }

    get $adValoremTotal() {
        return this.adValoremTotal
    }

    set $adValoremTotal(adValoremTotal) {
        const goods = this
        if ((!goods.taxRate && goods.taxRate !== 0) || !goods.isAmountSetable(adValoremTotal)) {
            return
        }
        goods.adValoremTotal = adValoremTotal
        if (!adValoremTotal || adValoremTotal === '-') {
            return
        }
        goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(adValoremTotal - goods.balance, goods.taxRate, goods.isTax))
        goods.amount = parseFloat(globalFn.Sub(adValoremTotal, goods.taxAmount))
        // 没有数量有单价 反算数量
        if (goods.taxPrice && goods.taxPrice != 0 && !goods.quantity) {
            goods.quantity = globalFn.cutOutPnumber(globalFn.Div(adValoremTotal, goods.taxPrice), 15)
            goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)
            // 没有单价有数量 反算单价
        } else if (goods.quantity && goods.quantity != 0 && goods.quantity) {
            goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(adValoremTotal, goods.quantity), 15)
            goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)
        }
        goods.taxAmount = Number(goods.taxAmount).toFixed(2)
        goods.amount = Number(goods.amount).toFixed(2)
    }

    get $quantity() {
        return this.quantity
    }

    set $quantity(quantity) {
        const goods = this
        if ((!goods.taxRate && goods.taxRate !== 0) || !goods.isQuantitySetable(quantity)) {
            return
        }
        goods.quantity = quantity
        if (!goods.quantity || goods.quantity === '-') {
            return
        }
        // 有单价 计算价税合计、税额、再反算不含税金额
        if (goods.isTax === '1') {
            if (goods.taxPrice) {
                goods.adValoremTotal = globalFn.Mul(quantity, goods.taxPrice)
                goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.adValoremTotal - goods.balance, goods.taxRate, goods.isTax))
                goods.amount = parseFloat(globalFn.Sub(goods.adValoremTotal, goods.taxAmount))
                goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)

                goods.taxAmount = goods.taxAmount.toFixed(2)
                goods.amount = goods.amount.toFixed(2)
                goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
            } else if (goods.adValoremTotal && goods.quantity != 0 && goods.quantity) { // 没有单价有金额 反算单价
                goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.quantity), 15)
                goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.adValoremTotal - goods.balance, goods.taxRate, goods.isTax))
                goods.amount = parseFloat(globalFn.Sub(goods.adValoremTotal, goods.taxAmount))
                goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)

                goods.taxAmount = goods.taxAmount.toFixed(2)
                goods.amount = goods.amount.toFixed(2)
            }
        } else if (goods.price) {
            goods.amount = globalFn.Mul(quantity, goods.price)
            goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.amount - goods.balance, goods.taxRate, '0'))
            goods.adValoremTotal = parseFloat(globalFn.Add(goods.amount, goods.taxAmount))
            goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.quantity), 15)
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.amount = goods.amount.toFixed(2)
            goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
        } else if (goods.amount && goods.quantity != 0 && goods.quantity) { // 没有单价有金额 反算单价
            goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)
            goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.amount - goods.balance, goods.taxRate, goods.isTax))
            goods.adValoremTotal = parseFloat(globalFn.Add(goods.amount, goods.taxAmount))
            goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.quantity), 15)
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
        }
    }

    isQuantitySetable(quantity = this.quantity) {
        if (!quantity || (!this.isRed && /^\d{1,11}(\.\d{0,2})?$/.test(quantity)) ||
            (this.isRed && /^-\d{0,12}(\.\d{0,2})?$/.test(quantity)) || this.isBill) {
            return true
        }
        return false
    }

    get $price() {
        return this.price
    }

    set $price(price) {
        const goods = this
        if ((!goods.taxRate && goods.taxRate !== 0) || !goods.isPriceSetable(price)) {
            return
        }
        goods.price = price
        if (price === '') {
            goods.taxPrice = ''
        }

        // 有数量就算不含税金额、价税合计
        if (goods.quantity) {
            goods.amount = globalFn.Mul(goods.quantity, goods.price)
            goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.amount - goods.balance, goods.taxRate, goods.isTax))
            goods.adValoremTotal = parseFloat(globalFn.Add(goods.amount, goods.taxAmount))
            goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.quantity), 15)
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.amount = goods.amount.toFixed(2)
            goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
        } else if (goods.amount && goods.price != 0 && goods.price) { // 有不含税金额没有数量，反算数量，税额
            goods.quantity = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.price), 15)
            goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.amount - goods.balance, goods.taxRate, goods.isTax))
            goods.adValoremTotal = parseFloat(globalFn.Add(goods.amount, goods.taxAmount))
            goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.quantity), 15)
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
        } else {
            if (goods.price === '' || goods.price === null) {
                goods.taxPrice = goods.price
            } else {
                goods.taxPrice = globalFn.cutOutPnumber(globalFn.Mul(goods.price, globalFn.Add(1, goods.taxRate)), 15)
            }
        }

    }

    isPriceSetable(price = this.price) {
        if (/^\d{1,11}(\.\d{0,15})?$/.test(price) || !price) {
            return true
        }
        return false
    }

    get $taxPrice() {
        return this.taxPrice
    }

    set $taxPrice(taxPrice) {
        const goods = this
        if ((!goods.taxRate && goods.taxRate !== 0) || !goods.isPriceSetable(taxPrice)) {
            return
        }
        goods.taxPrice = taxPrice
        if (taxPrice === '') {
            goods.price = ''
        }
        // 有数量就算不含税金额、价税合计
        if (goods.quantity) {
            goods.adValoremTotal = globalFn.Mul(goods.quantity, goods.taxPrice)
            goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.adValoremTotal - goods.balance, goods.taxRate, goods.isTax))
            goods.amount = parseFloat(globalFn.Sub(goods.adValoremTotal, goods.taxAmount))
            goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.amount = goods.amount.toFixed(2)
            goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
        } else if (goods.adValoremTotal && goods.taxPrice != 0 && goods.taxPrice) { // 有价税合计 没有数量 反算数量
            goods.quantity = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.taxPrice), 15)
            goods.taxRate != 10.02 && (goods.taxAmount = calculateTax(goods.adValoremTotal - goods.balance, goods.taxRate, goods.isTax))
            goods.amount = parseFloat(globalFn.Sub(goods.adValoremTotal, goods.taxAmount))
            goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.amount = goods.amount.toFixed(2)
        } else {
            if (goods.taxPrice === '' || goods.taxPrice === null) {
                goods.price = goods.taxPrice
            } else {
                goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.taxPrice, globalFn.Add(1, goods.taxRate)), 15)
            }
        }
    }

    get $taxRate() {
        return this.taxRate
    }

    set $taxRate(taxRate) {
        const goods = this
        if (taxRate === 0) {
            goods.zeroTax = '3'
        } else {
            goods.zeroTax = ''
        }
        goods.taxRate = taxRate
        if (goods.isTax === '1') {
            if (goods.adValoremTotal) {
                goods.taxAmount = calculateTax(goods.adValoremTotal - goods.balance, goods.taxRate, goods.isTax)
                goods.amount = parseFloat(globalFn.Sub(goods.adValoremTotal, goods.taxAmount))
                if (goods.quantity) {
                    goods.price = globalFn.cutOutPnumber(globalFn.Div(goods.amount, goods.quantity), 15)
                }
                
                goods.taxAmount = goods.taxAmount.toFixed(2)
                goods.amount = goods.amount.toFixed(2)
            }
        } else if (goods.amount) {
            goods.taxAmount = calculateTax(goods.amount - goods.balance, goods.taxRate, goods.isTax)
            goods.adValoremTotal = parseFloat(globalFn.Add(goods.amount, goods.taxAmount))
            if (goods.quantity) {
                goods.taxPrice = globalFn.cutOutPnumber(globalFn.Div(goods.adValoremTotal, goods.quantity), 15)
            }
            
            goods.taxAmount = goods.taxAmount.toFixed(2)
            goods.adValoremTotal = goods.adValoremTotal.toFixed(2)
        }
    }

    get $balance() {
        return this.balance
    }

    /**
     * 设置差额
     * @param  {bumber} balance 差额
     */
    set $balance(balance) {
        const goods = this
        goods.balance = balance
        let amt = goods.amount - goods.balance
        if (goods.isTax === '1') {
            amt = goods.adValoremTotal - goods.balance
            goods.taxAmount = calculateTax(amt, goods.taxRate, goods.isTax)
            goods.amount = parseFloat(globalFn.Sub(goods.adValoremTotal, goods.taxAmount)).toFixed(2)
        } else {
            goods.taxAmount = calculateTax(amt, goods.taxRate, goods.isTax)
            goods.adValoremTotal = parseFloat(globalFn.Add(goods.amount, goods.taxAmount)).toFixed(2)
        }

        goods.taxAmount = goods.taxAmount.toFixed(2)
        if (goods.quantity) {
            goods.taxPrice = globalFn.Div(goods.adValoremTotal, goods.quantity)
            goods.price = globalFn.Div(goods.amount, goods.quantity)
        } else if (goods.price) {
            goods.quantity = globalFn.Div(goods.amount, goods.price)
            goods.taxPrice = globalFn.Div(goods.adValoremTotal, goods.quantity)
        }
    }

    /**
     * 将商品行转换为折扣行
     * @param  {number}  discountRate 折扣率
     * @param  {string}  isTax        是否含税
     */
    toDiscountGoods(discountRate, isTax) {
        const discountGoods = this
        discountGoods.lineNature = '1'
        let adValoremTotal
        let taxAmount
        let amount
        if (isTax === '1') {
            adValoremTotal = -globalFn.Mul(discountGoods.adValoremTotal, discountRate)
            taxAmount = calculateTax(adValoremTotal, discountGoods.taxRate, '1')
            amount = globalFn.Sub(adValoremTotal, taxAmount)
        } else {
            amount = -globalFn.Mul(discountGoods.amount, discountRate)
            taxAmount = calculateTax(amount, discountGoods.taxRate, '0')
            adValoremTotal = globalFn.Add(amount, taxAmount)
        }
        discountGoods.quantity = ''
        discountGoods.spec = ''
        discountGoods.unit = ''
        discountGoods.price = ''
        discountGoods.taxPrice = ''
        discountGoods.balance = ''

        discountGoods.adValoremTotal = parseFloat(adValoremTotal).toFixed(2)
        discountGoods.amount = parseFloat(amount).toFixed(2)
        discountGoods.taxAmount = parseFloat(taxAmount).toFixed(2)
        return this
    }
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/model/Goods.js